export function accountHeaders() {
  const token = sessionStorage.getItem('reconnectToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}
